var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        "task-prop",
        "task-prop_responsible",
        { "task-prop_corrupted": _vm.corrupted },
      ],
    },
    [
      _c("strong", { staticClass: "task-prop__label" }, [
        _vm._v("Ответственный:"),
      ]),
      _vm._v(" "),
      _c("Select", {
        staticClass: "task-prop__value",
        attrs: {
          name: `responsible[]`,
          items: _vm.users,
          labelCallback: _vm.responsibleLabelCallback,
          active: _vm.value,
        },
        on: { selectChange: (v) => _vm.$emit("update", v) },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }